"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponseBody = exports.enable = exports.getCookies = exports.deleteCookies = void 0;
var trim_1 = __importDefault(require("licia/trim"));
var each_1 = __importDefault(require("licia/each"));
var decodeUriComponent_1 = __importDefault(require("licia/decodeUriComponent"));
var rmCookie_1 = __importDefault(require("licia/rmCookie"));
var once_1 = __importDefault(require("licia/once"));
var isNative_1 = __importDefault(require("licia/isNative"));
var contain_1 = __importDefault(require("licia/contain"));
var request_1 = require("../lib/request");
var connector_1 = __importDefault(require("../lib/connector"));
function deleteCookies(params) {
    rmCookie_1.default(params.name);
}
exports.deleteCookies = deleteCookies;
function getCookies() {
    var cookies = [];
    var cookie = document.cookie;
    if (trim_1.default(cookie) !== '') {
        each_1.default(cookie.split(';'), function (value) {
            value = value.split('=');
            var name = trim_1.default(value.shift());
            value = decodeUriComponent_1.default(value.join('='));
            cookies.push({
                name: name,
                value: value,
            });
        });
    }
    return { cookies: cookies };
}
exports.getCookies = getCookies;
var resTxtMap = new Map();
exports.enable = once_1.default(function () {
    var winXhrProto = window.XMLHttpRequest.prototype;
    var origSend = winXhrProto.send;
    var origOpen = winXhrProto.open;
    var origSetRequestHeader = winXhrProto.setRequestHeader;
    winXhrProto.open = function (method, url) {
        if (!isValidUrl(url)) {
            return origOpen.apply(this, arguments);
        }
        var xhr = this;
        var req = (xhr.chobitsuRequest = new request_1.XhrRequest(xhr, method, url));
        req.on('send', function (id, data) {
            var request = {
                method: data.method,
                url: data.url,
                headers: data.reqHeaders,
            };
            if (data.data) {
                request.postData = data.data;
            }
            connector_1.default.trigger('Network.requestWillBeSent', {
                requestId: id,
                type: 'XHR',
                request: request,
                timestamp: data.time / 1000,
            });
        });
        req.on('headersReceived', function (id, data) {
            connector_1.default.trigger('Network.responseReceivedExtraInfo', {
                requestId: id,
                blockedCookies: [],
                headers: data.resHeaders,
            });
        });
        req.on('done', function (id, data) {
            connector_1.default.trigger('Network.responseReceived', {
                requestId: id,
                type: 'XHR',
                response: {
                    status: data.status,
                },
                timestamp: data.time / 1000,
            });
            resTxtMap.set(id, data.resTxt);
            connector_1.default.trigger('Network.loadingFinished', {
                requestId: id,
                encodedDataLength: data.size,
                timestamp: data.time / 1000,
            });
        });
        xhr.addEventListener('readystatechange', function () {
            switch (xhr.readyState) {
                case 2:
                    return req.handleHeadersReceived();
                case 4:
                    return req.handleDone();
            }
        });
        origOpen.apply(this, arguments);
    };
    winXhrProto.send = function (data) {
        var req = this.chobitsuRequest;
        if (req)
            req.handleSend(data);
        origSend.apply(this, arguments);
    };
    winXhrProto.setRequestHeader = function (key, val) {
        var req = this.chobitsuRequest;
        if (req) {
            req.handleReqHeadersSet(key, val);
        }
        origSetRequestHeader.apply(this, arguments);
    };
    var isFetchSupported = false;
    if (window.fetch) {
        isFetchSupported = isNative_1.default(window.fetch);
    }
    if (!isFetchSupported && navigator.serviceWorker) {
        isFetchSupported = true;
    }
    if (!isFetchSupported)
        return;
    var origFetch = window.fetch;
    window.fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var req = new (request_1.FetchRequest.bind.apply(request_1.FetchRequest, __spreadArrays([void 0], args)))();
        req.on('send', function (id, data) {
            var request = {
                method: data.method,
                url: data.url,
                headers: data.reqHeaders,
            };
            if (data.data) {
                request.postData = data.data;
            }
            connector_1.default.trigger('Network.requestWillBeSent', {
                requestId: id,
                type: 'Fetch',
                request: request,
                timestamp: data.time / 1000,
            });
        });
        req.on('done', function (id, data) {
            connector_1.default.trigger('Network.responseReceived', {
                requestId: id,
                type: 'Fetch',
                response: {
                    status: data.status,
                    headers: data.resHeaders,
                },
                timestamp: data.time / 1000,
            });
            resTxtMap.set(id, data.resTxt);
            connector_1.default.trigger('Network.loadingFinished', {
                requestId: id,
                encodedDataLength: data.size,
                timestamp: data.time / 1000,
            });
        });
        var fetchResult = origFetch.apply(void 0, args);
        req.send(fetchResult);
        return fetchResult;
    };
});
function getResponseBody(params) {
    return {
        base64Encoded: false,
        body: resTxtMap.get(params.requestId),
    };
}
exports.getResponseBody = getResponseBody;
function isValidUrl(url) {
    return !contain_1.default(url, '__chobitsu-hide__=true');
}
